import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);

  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: { name: 'pending-estimations' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/estimations-a-realiser',
    name: 'pending-estimations',
    component: () => import('../views/Estimations/PendingEstimations.vue'),
  },
  {
    path: '/estimations-rejetees',
    name: 'rejected-estimations',
    component: () => import('../views/Estimations/RejectedEstimations.vue'),
  },
  {
    path: '/estimations-envoyees',
    name: 'sent-estimations',
    component: () => import('../views/Estimations/SentEstimations.vue'),
  },
  {
    path: '/estimations-expirees',
    name: 'outdated-estimations',
    component: () => import('../views/Estimations/OutdatedEstimations.vue'),
  },
  {
    path: '/estimation/:id',
    name: 'estimation-full-view',
    component: () => import('../views/Estimations/FullViewEstimations.vue'),
  },
  {
    path: '/clients',
    name: 'clients',
    component: () => import('../views/Clients/Clients.vue'),
  },
  {
    path: '/transactions-validees',
    name: 'validated-transactions',
    component: () => import('../views/Transactions/ValidatedTransactions.vue'),
  },
  {
    path: '/transactions-en-attente',
    name: 'pending-transactions',
    component: () => import('../views/Transactions/PendingTransactions.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { getters, dispatch } = store;

  if (!getters['user/getUserLogged']) {
    dispatch('auth/setUserToken');
  }

  if (to.name !== 'login' && !getters['user/getUserLogged']) {
    return next({ name: 'login' });
  }

  next();
});

export default router;
